import { useEffect, useState } from 'react';
import Spin from 'antd/lib/spin';
import { Redirect } from 'react-router-dom';
import AppLayout from 'components/AppLayout';
import { initInternalization } from 'localization/localization';
import { isInitialSetupCompleted, termsAndConditionsAccepted } from 'utils/userUtils';
import './styles/App.less';
import { useDispatch, useSelector } from 'react-redux';
import { isAdminSelector, isUserInfoLoadingSelector, userSelector, userTagsSelector } from 'redux/selectors/userSelector';
import { checkUserRole, getUserInfo, getUserTags } from 'redux/reducers/authenticationSlice';
import { ContentProviderAccountDto } from './api';
import { AppDispatch } from './redux/store';
import { useAuth0 } from '@auth0/auth0-react';
import { isEmpty } from 'lodash';
import flagsmith from 'flagsmith';
import { FlagsmithProvider } from 'flagsmith/react';
import { getCountries } from 'redux/reducers/regionSlice';
import forgotPasswordConfig from 'auth/forgotPasswordConfig';

export default function App() {
	const [isLocaleInit, setIsLocaleInit] = useState(false);
	const { isLoading: isAuth0Loading, user, getIdTokenClaims, loginWithRedirect, logout, isAuthenticated } = useAuth0();
	const userData = useSelector(userSelector);
	const isAdmin = useSelector(isAdminSelector);
	const userTags = useSelector(userTagsSelector);
	const isUserInfoLoading = useSelector(isUserInfoLoadingSelector);
	const dispatch: AppDispatch = useDispatch();
	const urlParams = new URLSearchParams(window.location.search);

	useEffect(() => {
		initInternalization();
	}, [dispatch]);

	useEffect(() => {
		console.log('isAuthenticated', isAuthenticated);
		console.log('isAuth0Loading', isAuth0Loading);
		// 只在认证完成且 Auth0 加载结束时执行
		if (!isAuthenticated || isAuth0Loading) {
			return;
		}

		const init = async () => {
			await initInternalization();
			await dispatch(getCountries());
			await dispatch(getUserInfo());
		};
		init();
	}, [isAuthenticated, isAuth0Loading, dispatch]);

	useEffect(() => {
		// 只在认证完成、Auth0加载结束、且userData有userId时执行
		if (!isAuthenticated || isAuth0Loading || !userData?.userId) {
			return;
		}

		if (isInitialSetupCompleted(userData)) {
			dispatch(getUserTags(userData.userId));
		}
	}, [isAuthenticated, isAuth0Loading, userData?.userId, dispatch]);

	// useEffect(() => {
	// 	const getUserClaims = async () => {
	// 		await dispatch(checkUserRole(getIdTokenClaims));
	// 	};
	// 	getUserClaims();
	// }, [user]);

	const redirectUser = (userData: ContentProviderAccountDto | null, userTags) => {
		if (!userData!.emailVerified) {
			return <Redirect to="email-verification" />;
		} else if (!termsAndConditionsAccepted(userData!)) {
			return <Redirect to="/toc" />;
		} else if (!isInitialSetupCompleted(userData!)) {
			return <Redirect to="/profile-setup" />;
		} else {
			return <Redirect to="/profile-information" />;
		}
	};

	useEffect(() => {
		if (urlParams.get('forgotPassword') === 'true' && !isAuth0Loading) {
			if (isAuthenticated) {
				logout({
					returnTo: window.location.origin + '/?forgotPassword=true',
				});
				localStorage.clear();
			} else {
				loginWithRedirect(forgotPasswordConfig);
			}
		}
	}, [isAuth0Loading, isAuthenticated, logout, loginWithRedirect]);

	console.log('userData', userData);
	// console.log('user', user);
	// console.log('isAuthenticated', isAuthenticated);
	// console.log('isAuth0Loading', isAuth0Loading);
	// console.log('isUserInfoLoading', isUserInfoLoading);

	if (isAuth0Loading || urlParams.get('forgotPassword') === 'true' || isUserInfoLoading) return <Spin />;

	return (
		<>
			<AppLayout />
			{userData ? redirectUser(userData, userTags) : null}
		</>
	);
}
